export { default as SyrasoftConnectMini } from '../../../../assets/images/SyrasoftConnectMini.svg';
export { default as SyrasoftConnectTaglineWhite } from '../../../../assets/images/SyrasoftConnectTaglineWhite.svg';
export { default as SyrasoftConnectTaglineBlack } from '../../../../assets/images/SyrasoftConnectTaglineBlack.svg';
